import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

// Styled components

export const FreeShippingBanner = styled(Box)({
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  textDecoration: "none",
  color: "inherit",
  backgroundColor: "lightgrey",
  borderRadius: "5%",
  flexGrow: 1
});
